<template>
  <div
    v-tooltip="eventTooltip"
    class="week-event p-5"
    :class="{ 'a-tooltip': showImportedTimeOffBadge }"
    :aria-label="bambooHrEventAriaLabel"
    :style="defaultStyle"
    :data-testid="showImportedTimeOffBadge ? 'schedules-time-off-event' : null"
  >
    <div class="event-details">
      <template v-if="showUserDetails">
        <span
          v-if="showAssigneeCount"
          v-tooltip="true"
          class="more-members-badge light a-tooltip"
          data-html="true"
          :title="event.extendedProps.assignee_names.join('<br/>')"
        >
          {{ event.extendedProps.assignee_count }}
        </span>
        <HubAvatar
          v-else
          :user-id="resourceId"
          :users-avatars="usersAvatars"
          avatar-style="speck"
          class="mb-5"
        />
      </template>

      <div class="d-flex flex-column">
        <template v-if="showUserDetails && !showAssigneeCount">
          <div class="name d-flex align-items-center min-w-0">
            <TimeOffRequestBambooHrBadge
              v-if="showImportedTimeOffBadge"
              class="mr-5"
            />
            <span class="text-truncate">{{ userRealName }}</span>
          </div>
          <span class="type">{{ type }}</span>
        </template>
        <template v-else-if="isHoliday">
          <span class="name">{{ event.title }}</span>
          <span class="type">{{ type }}</span>
        </template>
        <span
          v-else
          class="name"
        >
          {{ event.title }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import SchedulesEventMixin from '~/mixins/attendance_schedules/SchedulesEventMixin';
import TimeOffRequestBambooHrBadge from '~/components/time_off/TimeOffRequestBambooHrBadge.vue';
import { createUsersAvatarsMixin } from '~/mixins/UsersAvatarsMixin';
import tooltipDirective from '~/directives/tooltip';

export default {
  name: 'WeekViewEvent',
  components: { TimeOffRequestBambooHrBadge },
  directives: { tooltip: tooltipDirective },
  mixins: [SchedulesEventMixin, createUsersAvatarsMixin('assignedMember')],
  props: {
    event: {
      type: Object,
      required: true,
    },
  },
  computed: {
    assignedMember() {
      return [{ id: Number(this.resourceId), avatar: this.avatar }];
    },
    isHoliday() {
      return this.type === 'Holiday';
    },
    showUserDetails() {
      return ['Shift', 'Time off request', 'Job'].includes(this.type);
    },
    showAssigneeCount() {
      return this.type === 'Job' && this.event.extendedProps.assignee_count > 1;
    },
  },
};
</script>
